import React, { useEffect, useState } from 'react';
import { IPropertyWizardInput } from './NewPropertyWizard';
import styles from './Address.scss';
import { IProperty } from '../../utils/JsonApiRequest';
import Tooltip from '../Tooltip';
// import Checkbox from '../Checkbox';
import TextField from '../MaterialUi/TextField';
import Checkbox from '../MaterialUi/Checkbox';
import { inputPatterns } from '../../utils/inputPatterns';

export interface IAddressProps extends IPropertyWizardInput { }

const Address: React.FC<React.PropsWithChildren<IAddressProps>> = ({ step = null, data = null, onChange = () => { } }) => {
    // const [nextAddress, setNextAddress] = useState({ ...data.field_address } || ({} as IProperty['field_address']));

    // const handleEditorChange = (ev: CKEditor) => {
    //     const value = ev.editor.getData();
    //     onChange('objektbeschreibung', value);
    // };

    const [nextAddress, setNextAddress] = useState(data?.field_address);
    const [nextCheckbox, setNextCheckbox] = useState(data?.objektadresse_freigeben);

    useEffect(() => {
        setNextAddress(data?.field_address);
        setNextCheckbox(data?.objektadresse_freigeben);
    }, [data]);

    const handleAddressFieldChange = (ev: React.FormEvent) => {
        const field = ev.target as HTMLInputElement;
        const data = nextAddress || ({} as IProperty['field_address']);
        data[field.name] = field.value;
        // setNextAddress({ ...data });

        // if (data?.address_line1 && data?.postal_code && data?.locality) {
        onChange('field_address', data);
        setNextAddress({ ...data });
    };

    const handleSwitchChange = (ev) => {
        onChange('objektadresse_freigeben', ev.target.checked);
        setNextCheckbox(ev.target.checked);
    };

    const isValid = (name: keyof IProperty['field_address']) => {
        if (name === 'postal_code') {
            const nr = Number(nextAddress?.[name] || 0);
            return Number.isInteger(nr) && nr >= 0 && nr <= 99999 && (nextAddress?.[name] || '').length <= 5;
        } else {
            return !nextAddress?.[name] || nextAddress[name]?.length <= 255;
        }
    };

    const validHint = 'Bitte maximal 255 Zeichen verwenden.';

    return (
        <div className={styles.address}>
            <div className={styles.wide}>
                <TextField
                    name="address_line1"
                    value={nextAddress?.address_line1 || ''}
                    onChange={handleAddressFieldChange}
                    label="Straße und Hausnummer"
                    required={data.objektadresse_freigeben !== false}
                    error={!isValid('address_line1')}
                    helperText={!isValid('address_line1') ? validHint : ''}
                ></TextField>
            </div>
            <div className={styles.postalCode}>
                <TextField
                    name="postal_code"
                    value={nextAddress?.postal_code || ''}
                    onChange={handleAddressFieldChange}
                    label="Postleitzahl"
                    required={true}
                    inputMode="numeric"
                    pattern={inputPatterns.postalCode}
                    error={!isValid('postal_code')}
                    helperText={!isValid('postal_code') ? 'Bitte eine korrekte deutsche Postleitzahl eingeben.' : ''}
                ></TextField>
            </div>
            <div className={styles.locality}>
                <TextField
                    name="locality"
                    value={nextAddress?.locality || ''}
                    onChange={handleAddressFieldChange}
                    label="Stadt"
                    required={true}
                    error={!isValid('locality')}
                    helperText={!isValid('locality') ? validHint : ''}
                ></TextField>
            </div>
            <div className={styles.withInfo}>
                {/* <Switch checked={data.objektadresse_freigeben !== false} id="switch-2" offLabel="" onChange={handleSwitchChange} onLabel="" /> */}
                <Checkbox
                    onChange={handleSwitchChange}
                    // value="true"
                    name="objektadresse_freigeben"
                    value={nextCheckbox === true}
                    label="Straße und Hausnummer im Immobilieninserat anzeigen."
                />
                {/* <span>Straße und Hausnummer im Immobilieninserat anzeigen.</span> */}
                <Tooltip className={styles.info}>
                    Wenn Sie die genaue Adresse anzeigen, wird Ihre Immobilie eher gefunden, weil die genaue Lage ein entscheidendes Kriterium für Interessenten
                    ist.
                </Tooltip>
            </div>
        </div>
    );
};

export default Address;
